class PolicyModal {
  /**
   * @param {HTMLElement} root
   */
  constructor(root) {
    this.root = root;
    this.dialog = root.querySelector('dialog.policy-modal');
    this.listView = root.querySelector('[data-policy-view="list"]');
    this.docView = root.querySelector('[data-policy-view="doc"]');
    this.titleEl = root.querySelector('[data-policy-doc-title]');
    this.bodyEl = root.querySelector('[data-policy-doc-body]');

    root.querySelectorAll('[data-policy-open]').forEach((button) => {
      button.addEventListener('click', () => this.#openDoc(button));
    });

    root.querySelector('[data-policy-back]')?.addEventListener('click', () => this.#showList());
    this.dialog?.addEventListener('close', () => this.#showList());
  }

  /**
   * @param {HTMLElement} button
   */
  #openDoc(button) {
    const href = button.dataset.policyHref;
    if (href) {
      window.location.href = href;
      return;
    }

    const template = document.getElementById(button.dataset.policyTemplate || '');
    if (!(template instanceof HTMLTemplateElement) || !this.titleEl || !this.bodyEl) return;

    this.titleEl.textContent = button.dataset.policyTitle || '';
    this.bodyEl.replaceChildren(template.content.cloneNode(true));
    this.dialog?.classList.add('is-reading');
    this.listView?.setAttribute('hidden', '');
    this.docView?.removeAttribute('hidden');
    this.bodyEl.scrollTop = 0;
  }

  #showList() {
    this.dialog?.classList.remove('is-reading');
    this.docView?.setAttribute('hidden', '');
    this.listView?.removeAttribute('hidden');
    if (this.bodyEl) this.bodyEl.replaceChildren();
  }
}

document.querySelectorAll('dialog-component.footer-utilities__policy-list').forEach((root) => {
  new PolicyModal(root);
});
